import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookItem } from '../components/Elze/BookItem';
import { Book, Plus, Settings, Filter } from 'lucide-react';
type WorkStatus = 'all' | 'published' | 'unpublished' | 'in-progress' | 'in-transfer';
export function MyWorksPage() {
  const [activeTab, setActiveTab] = useState<WorkStatus>('all');
  const [showAddBookModal, setShowAddBookModal] = useState(false);
  const navigate = useNavigate();
  // Work data
  const works = [{
    id: '1',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp',
    title: 'The Garden Among Clouds',
    genre: 'Novel',
    year: '2023',
    status: 'in-progress'
  }, {
    id: '2',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp',
    title: 'Love & Lies',
    genre: 'Novel',
    year: '2022',
    status: 'published'
  }, {
    id: '3',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
    title: 'The Mist Forest',
    genre: 'Thriller',
    year: '2021',
    status: 'published'
  }, {
    id: '4',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/omrsrDbXdUTTrHR98EvY6a/IMG_0034.webp',
    title: 'My Prayer Diary',
    genre: 'Spiritual',
    year: '2020',
    status: 'published'
  }, {
    id: '5',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mH3hvE4SdWb6hacSUtkerR/IMG_0029.webp',
    title: 'Think Like A Boss',
    genre: 'Personal Development',
    year: '2021',
    status: 'unpublished'
  }, {
    id: '6',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
    title: 'The Silent Echo',
    genre: 'Fiction',
    year: '2019',
    status: 'in-transfer'
  }, {
    id: '7',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp',
    title: 'Verses of the Soul',
    genre: 'Poetry',
    year: '2024',
    status: 'unpublished'
  }, {
    id: '8',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp',
    title: 'Modern Reflections',
    genre: 'Essays',
    year: '2024',
    status: 'in-progress'
  }];
  // Filter works based on active tab
  const filteredWorks = works.filter(work => {
    if (activeTab === 'all') return true;
    return work.status === activeTab;
  });
  // Counts for tabs
  const counts = {
    all: works.length,
    published: works.filter(w => w.status === 'published').length,
    unpublished: works.filter(w => w.status === 'unpublished').length,
    'in-progress': works.filter(w => w.status === 'in-progress').length,
    'in-transfer': works.filter(w => w.status === 'in-transfer').length
  };
  const tabs = [{
    id: 'all',
    label: 'All',
    count: counts.all
  }, {
    id: 'published',
    label: 'Published',
    count: counts.published
  }, {
    id: 'unpublished',
    label: 'Unpublished',
    count: counts.unpublished
  }, {
    id: 'in-progress',
    label: 'In Progress',
    count: counts['in-progress']
  }, {
    id: 'in-transfer',
    label: 'In Transfer',
    count: counts['in-transfer']
  }];
  // Handle book click
  const handleBookClick = bookId => {
    navigate(`/book/${bookId}`);
  };
  return <div className="w-full bg-gray-50 min-h-screen" data-id="element-744">
      {/* Header */}
      <div className="mb-4 sm:mb-6 md:mb-8" data-id="element-745">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-746">
          <div data-id="element-747">
            <h1 className="text-2xl md:text-3xl font-bold text-[#164149]" data-id="element-748">
              My Works
            </h1>
          </div>
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-749">
            <button onClick={() => setShowAddBookModal(true)} className="flex items-center px-4 py-2 bg-[#C6D6AB] text-gray-800 rounded-md hover:bg-[#b8c99a] transition-colors" data-id="element-750">
              <Plus size={16} className="mr-2" data-id="element-751" />
              Add New Work
            </button>
            <button className="px-3 sm:px-4 py-2 sm:py-2.5 bg-white border border-gray-300 text-gray-700 rounded-md text-sm font-medium flex items-center justify-center space-x-2 hover:bg-gray-50 transition-colors" data-id="element-752">
              <Settings size={16} data-id="element-753" />
              <span data-id="element-754">Channel Management</span>
            </button>
          </div>
        </div>
      </div>
      {/* Tabs - with horizontal scrolling for mobile */}
      <div className="mb-6 sm:mb-8" data-id="element-755">
        <div className="border-b border-gray-200 overflow-x-auto scrollbar-hide" data-id="element-756">
          <nav className="flex space-x-4 sm:space-x-8 min-w-max" data-id="element-757">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id as WorkStatus)} className={`py-3 sm:py-4 px-1 border-b-2 font-medium text-xs sm:text-sm whitespace-nowrap transition-colors ${activeTab === tab.id ? 'border-[#161c2d] text-[#164149]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-758">
                {tab.label}
                <span className={`ml-1 sm:ml-2 py-0.5 px-1.5 sm:px-2 rounded-full text-xs ${activeTab === tab.id ? 'bg-[#161c2d] text-white' : 'bg-gray-100 text-gray-600'}`} data-id="element-759">
                  {tab.count}
                </span>
              </button>)}
          </nav>
        </div>
      </div>
      {/* Works Grid - Modified for tablet: 4 columns */}
      {filteredWorks.length > 0 ? <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4 md:gap-5 lg:gap-6" data-id="element-760">
          {filteredWorks.map(work => <div key={work.id} className="w-full aspect-[1/1.2] cursor-pointer transition-transform hover:scale-[1.02]" onClick={() => handleBookClick(work.id)} data-id="element-761">
              <BookItem cover={work.cover} title={work.title} genre={work.genre} year={work.year} authorImage={'https://i.sstatic.net/l60Hf.png'} id={work.id} data-id="element-762" />
            </div>)}
        </div> : <div className="text-center py-8 sm:py-12" data-id="element-763">
          <div className="mx-auto h-16 w-16 sm:h-24 sm:w-24 text-gray-400 mb-4" data-id="element-764">
            <Filter size={64} className="mx-auto sm:hidden" data-id="element-765" />
            <Filter size={96} className="mx-auto hidden sm:block" data-id="element-766" />
          </div>
          <h3 className="text-base sm:text-lg font-medium text-[#164149] mb-2" data-id="element-767">
            No works found
          </h3>
          <p className="text-sm sm:text-base text-gray-600" data-id="element-768">
            There are no works matching the selected filters.
          </p>
        </div>}
    </div>;
}